module.exports = __webpack_public_path__ + "static/media/volumemobile.bea86af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/icons/volumemobile.png
// module id = 966
// module chunks = 0